
/* injects from baggage-loader */

import React from 'react';
import PropTypes, { number } from 'prop-types';
import SmartTable from '../../../../components/smartTable';
import { casinoBetTicketsColumnConfig, casinoTicketsInfoColumnConfig } from '../constants/tableConfigs';
import { t } from '../../../../helpers/translator';
import CasinoNumbers from '../components/casinoNumbers';

class CasinoTicketInfo extends React.Component {
    constructor(props) {
        super(props);
        this.casinoTicketsInfoColumnConfig = casinoTicketsInfoColumnConfig.bind(this);
    }

    render() {
        const { betInfo } = this.props;
        const [numbers] = betInfo.win_info?.Result?.Numbers || [];

        return <div className='ticket-b-info-w-inside'>
            <SmartTable
                className="ticket-casino-table-inside"
                columnConfig={this.casinoTicketsInfoColumnConfig()}
                data={[betInfo]}
            />

            {numbers && <CasinoNumbers numbers={numbers} />}
        </div>;
    }
}

class CasinoTicket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedTransId: null,
        };
        this.casinoBetTicketsColumnConfig = casinoBetTicketsColumnConfig.bind(this);
    }

    render() {
        const { expandedTransId } = this.state;
        const { dataFromCasino, dataFromSwarm } = this.props;

        return <SmartTable
            columnConfig={this.casinoBetTicketsColumnConfig()}
            // eslint-disable-next-line react/jsx-no-bind
            activeRowOpen={item => expandedTransId === item.TransactionId}
            // eslint-disable-next-line react/jsx-no-bind
            className="ticket-b-table"
            rowClick={(e, item) => this.setState({ expandedTransId: expandedTransId === item.TransactionId ? null : item.TransactionId })}
            data={dataFromCasino.BetMultiplyInfo}
            // eslint-disable-next-line react/jsx-no-bind
            activeRowContent={item => <CasinoTicketInfo
                betInfo={item}
                dataFromSwarm={dataFromSwarm}
            />}
        />;
    }
}
CasinoTicket.propTypes = {
    dataFromCasino: PropTypes.object,
    dataFromSwarm: PropTypes.object
};
export default CasinoTicket;